import React from 'react';
import PropTypes from 'prop-types';

import Registry from '../../../registry/index';


const PmTypingNotification = ({ user, genderClass }) => {
    const lang = Registry.get('locale');
    return (
        <div className="message dont-break-out typing">
            <span className={"author " + genderClass}>{user.nick}</span> {lang.colon} <div className="typing-indicator">
                <span />
                <span />
                <span />
            </div>
        </div>
    )
}

PmTypingNotification.propTypes = {
    user: PropTypes.object.isRequired,
    genderClass: PropTypes.string.isRequired,
};

export default PmTypingNotification;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmTypingNotification/index.js